import { arrivalsRoute } from '@/features/arrivals/routes'
import {
  loginAsRoute,
  loginRoute,
  loginSsoCallbackRoute,
  loginSsoRoute,
  loginv1Route,
  loginv2CallbackRoute,
  loginv2Route,
  resetPasswordRoute,
  shipV1LoginAsRedirect,
  signupInvitedRoute,
} from '@/features/auth/routes'
import { averageFxRateRoute } from '@/features/averageFxRate/routes'
import { billingRoute } from '@/features/billing/routes'
import { bookingsRoutes } from '@/features/bookings/routes'
import { companyDocumentsRoute } from '@/features/company/routes'
import { companyAccountRoute } from '@/features/companyAccount/routes'
import { dashboardRoute } from '@/features/dashboard/routes'
import { integrationsRoute } from '@/features/integrations/routes'
import {
  notificationRoute,
  notificationSelectRoute,
  notificationSettingsRoute,
  notificationsRoute,
} from '@/features/notifications/routes'
import { quotesLayoutRoute, quotesRoute } from '@/features/quotes/routes'
import {
  reportCreateLayoutRoute,
  reportCreateRoute,
  reportEditLayoutRoute,
  reportEditRoute,
  reportsLayoutRoute,
  reportsRoute,
  reportWebsocketRoute,
} from '@/features/reports/routes'
import { settingsRoute, verifyEmailRoute } from '@/features/settings/routes'
import {
  overviewRoute,
  shipmentChargesRoute,
  shipmentContainersRoute,
  shipmentCustomsRoute,
  shipmentDetailsRoute,
  shipmentDocumentsRoute,
  shipmentPriceBreakdownRoute,
  shipmentRoute,
  shipmentsRoute,
} from '@/features/shipments/routes'
import { requiredActionsRoute } from '@/features/shipments/view/requiredActions/routes'
import { supportRoute } from '@/features/support/routes'
import { companyUsersRoute, companyUsersSsoRoute } from '@/features/users/routes'

import { redirectShipV1Routes } from './redirectShipV1Routes'
import { rootRoute } from './root'

export const routeTree = rootRoute.addChildren([
  ...redirectShipV1Routes,
  arrivalsRoute,
  overviewRoute,
  dashboardRoute,
  billingRoute,
  quotesLayoutRoute.addChildren([quotesRoute]),
  reportWebsocketRoute.addChildren([
    reportsLayoutRoute.addChildren([reportsRoute]),
    reportCreateLayoutRoute.addChildren([reportCreateRoute]),
    reportEditLayoutRoute.addChildren([reportEditRoute]),
  ]),
  shipmentsRoute,
  requiredActionsRoute,
  shipmentRoute.addChildren([
    shipmentDetailsRoute,
    shipmentContainersRoute,
    shipmentPriceBreakdownRoute,
    shipmentChargesRoute,
    shipmentCustomsRoute,
    shipmentDocumentsRoute,
  ]), // Not under layout component because it has multiple loaders
  loginRoute,
  loginv1Route,
  loginv2Route,
  loginv2CallbackRoute,
  loginSsoRoute,
  loginSsoCallbackRoute,
  loginAsRoute,
  shipV1LoginAsRedirect,
  resetPasswordRoute,
  signupInvitedRoute,
  averageFxRateRoute,
  companyUsersRoute,
  companyUsersSsoRoute,
  companyDocumentsRoute,
  companyAccountRoute,
  supportRoute,
  settingsRoute,
  verifyEmailRoute,
  integrationsRoute,
  notificationsRoute.addChildren([notificationSelectRoute, notificationRoute]),
  notificationSettingsRoute,
  ...bookingsRoutes,
])
